<template>
  <div class="Mail">
    <el-dialog :title="$t('mail.title')" class="Mail" append-to-body v-el-drag-dialog 
    :visible.sync="dialogFormVisible" width="800px" :before-close="handleClose">
      <el-form label-width="85px" @submit.native.prevent>
        <el-form-item :label="$t('mail.address')">
          <addressee :address="temp.address" :disabled="!mailInfo.edit||((mailInfo.editOption&1)!==1)"/>
        </el-form-item>
        <el-form-item :label="$t('mail.copy')">
          <addressee :address="temp.copy" :disabled="!mailInfo.edit||((mailInfo.editOption&2)!==2)"/>
        </el-form-item>
        <el-form-item :label="$t('mail.subject')">
          <el-input class="subject-input" v-if="mailInfo.edit&&((mailInfo.editOption&4)===4)" v-model="temp.subject">{{temp.subject}}</el-input>
          <el-scrollbar v-else>
            <p style="height:32px;padding:0px 15px" v-html="temp.subject"></p>
          </el-scrollbar>
        </el-form-item>
        <el-form-item :label="$t('mail.body')">
          <div class="el-textarea el-input--small">
            <textarea v-if="mailInfo.edit&&((mailInfo.editOption&8)===8)" autocomplete="off" placeholder=""
            class="el-textarea__inner" style="height:200px;padding:5px 15px" v-model="temp.body"></textarea>
            <textarea v-else placeholder="" readonly
            class="el-textarea__inner" style="height:200px;padding:5px 15px" v-model="temp.body"></textarea>
            <!-- <div class="el-textarea__inner" style="padding:0" v-else>
              <el-scrollbar>
                <p style="height:200px;padding:5px 15px" v-html="temp.body"></p>
              </el-scrollbar>
            </div> -->
          </div>
        </el-form-item>
        <el-form-item :label="$t('mail.attach')">
          <!-- <el-button type="text" icon="el-icon-circle-plus-outline" @click="moreAttach"></el-button> -->
          <el-button plain style="padding:5px;margin-right:6px" size="mini" icon="el-icon-plus" @click="moreAttach"></el-button>
          <el-link type="info" v-if="temp.attach&&temp.attach.length>0" v-for="(attach,index) in temp.attach" :key="index" :underline="false">
            <!-- <svg-icon icon-class="attachment"></svg-icon> -->
            <span @click.stop.prevent="handleEdit(attach, index)" v-if="index!==attachIndex">
              {{attach.name}}
            </span>
            <el-input style="width:100px" size="mini" ref="attachName" v-else v-model="attachName" @blur="handleBlur($event, attach)" @keyup.enter.native="$refs.attachName[0].blur()"/>
            <el-button v-if="index!==attachIndex" type="text" icon="el-icon-error" @click="temp.attach.splice(index,1)" class="delete-button"></el-button>
          </el-link>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="sendMail" type="primary" icon="el-icon-s-promotion" :loading="sending">{{$t('mail.send')}}</el-button>
        <el-button @click="beforeCancel" icon="el-icon-close">{{$t('mail.cancel')}}</el-button>
      </div>
      <input ref="fileInput" id="fileInput" name="fileInput" type="file" @change="onSelectedFile" 
        multiple="multiple" style="display:none"/>
    </el-dialog>
  </div>
</template>
<script>
import Addressee from './Addressee'
import {
  SendMail
} from '@/api/form.js'
export default {
  name: 'Mail',
  components: {
    Addressee
  },
  data() {
    return {
      attachName: '',
      attachIndex: null,
      temp: {
        addressees: [],
        copy: [],
        subject: '',
        body: '',
        attach: []
      },
      dialogFormVisible: false,
      mailInfo: {},
      sending: true
    }
  },
  methods: {
    handleBlur(val, attach) {
      const suffix = attach.name.substring(attach.name.lastIndexOf('.') + 1, attach.name.length)
      attach = new File([attach], this.attachName + '.' + suffix, {type: attach.type})
      this.$set(this.temp.attach, this.attachIndex, attach)
      this.attachIndex = null
    },
    handleEdit(attach, index) {
      this.attachIndex = index
      const index1 = attach.name.lastIndexOf('.')
      this.attachName = attach.name.substring(0, index1)

      this.$nextTick(() => {
        this.$refs.attachName[0].focus()
        this.$refs.attachName[0].select()
      })
    },
    handleMail(mailInfo, mailContent) {
      this.mailInfo = mailInfo
      this.temp = mailContent
      this.sending = false
      this.dialogFormVisible = !mailInfo.silence
      this.$nextTick(() => {
        switch (mailInfo.contentArea) {
          case null:
            if (this.mailInfo.silence) {
              this.sendMail()
            }
            break
          case '1':
            this.$emit('ExportExcelFile', this.temp, this)
            break
          default:
            this.$emit('ExportPDFFile', this.mailInfo, this.temp, this)
            break
        }
      })
    },
    sendMail() {
      this.sending = true
      var param = new FormData()
      param.append('address', JSON.stringify(this.temp.address))
      param.append('copy', JSON.stringify(this.temp.copy))
      param.append('subject', this.temp.subject)
      param.append('body', this.temp.body)
      this.temp.attach.forEach(item => {
        param.append('file', item, item.name)
      })
      SendMail(0, param)
      this.$notify({
        title: this.$t('status.warning'),
        message: this.mailInfo.name + this.$t('mail.success'),
        type: 'success'
      })
      this.dialogFormVisible = false
      // 发送邮件
      this.$nextTick(() => {
        this.$emit('SendMailByStep')
      })
      this.sending = false
    },
    handleClose(done) {
      this.$confirm(this.$t('mail.isCancel'), this.$t('status.warning'))
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    beforeCancel() {
      this.$confirm(this.$t('mail.isCancel'), this.$t('status.warning'))
        .then(_ => {
          this.dialogFormVisible = false
        })
        .catch(_ => {})
    },
    moreAttach() {
      this.$refs.fileInput.dispatchEvent(new MouseEvent('click'))
    },
    onSelectedFile() {
      var fileList = this.$refs.fileInput.files
      if (!this.temp.attach) {
        this.temp.attach = []
      }
      for (var i = 0; i < fileList.length; i++) {
        // this.temp.attach.push(fileList[i])
        this.$set(this.temp.attach, this.temp.attach.length, fileList[i])
      }
      this.$refs.fileInput.value = ''
    }
  }
}
</script>
<style lang="scss">
.Mail{
  a.el-link{
    display: inline-block !important;
    margin-right: 8px;
    .svg-icon{
      width: 12px;
      height: 12px;
    }
  }
  .el-form-item__content{
    border-bottom:1px solid #e8eaec !important;
  }
  .el-form-item:last-child{
    .el-form-item__content{
      border-bottom:none
    }
  }
  .subject-input .el-input__inner{
    border: none;
  }
  .el-link:hover{
    .delete-button{
      visibility: visible;
    }
  }
  .delete-button{
    position: absolute;
    top: -8px;
    right: -9px;
    visibility: hidden;
  }
}
  
</style>